var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",class:{
    en: _vm.$i18n.locale === 'en-US',
  },attrs:{"id":"app"}},[_c('HeaderComponent'),_c('div',{attrs:{"id":"module2Content"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }